import { app } from '../../../../../../app';

app.service('EditProfileBasicModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (profile) => {
        return $uibModal.open({
            component: 'editProfileBasic',
            resolve: {
                genders,
                maritalStates,
                profile: () => profile,
            }
        }).result;
    };
}

/** @ngInject */
function genders($http) {
    return $http.get('app/rest/genders').then((response) => response.data);
}

/** @ngInject */
function maritalStates($http) {
    return $http.get('app/rest/maritalstatuses').then((response) => response.data);
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/basic/edit/edit.modal.js